var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenconnector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104.036,
    height: 78,
    viewBox: "2 0 104 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03617 0.714793L0.869141 0.715942L1.03531 24.8661L14.1201 24.7761L14.1201 24.7759C12.4241 24.7896 10.7403 24.178 9.16473 22.976C7.58917 21.7741 6.15282 20.0053 4.93775 17.7708C3.72268 15.5363 2.7527 12.8798 2.08325 9.95326C1.41382 7.02675 1.05801 3.88747 1.03617 0.714793Z",
    fill: "green",
    fillOpacity: 0.97
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.78213 56.7835L1.30591 56.7867L1.13597 32.0877L16.3252 31.9832L16.3252 31.991C14.4636 32.0694 12.6284 32.7155 10.9136 33.8981C9.09677 35.151 7.45063 36.9814 6.0692 39.2847C4.68777 41.5881 3.59812 44.3192 2.86253 47.3221C2.1271 50.3243 1.75998 53.5393 1.78213 56.7835Z",
    fill: "green",
    fillOpacity: 0.97
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05591,
    y: 24.7134,
    width: 113,
    height: 7.8,
    transform: "rotate(-0.394217 1.05591 24.7134)",
    fill: "green",
    fillOpacity: 0.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenconnector);
export default __webpack_public_path__ + "static/media/greenconnector.6367284a21b709dbf522d9e36cdb43d8.svg";
export { ForwardRef as ReactComponent };